import { toast } from 'sonner';
import { usePersonForms, useSetPersonForm } from '../../../../hooks/onboardingOps';
import { AssignItemList } from '../../../../components/onboarding/AssignItemList';
import { ApiError } from '../../../../lib/api';

/** Pick the onboarding forms the new starter has to fill in. */
export function FormsStep({ personId }: { personId: string }) {
  const forms = usePersonForms(personId);
  const set = useSetPersonForm(personId);

  async function toggle(formId: string, assigned: boolean) {
    try {
      await set.mutateAsync({ formId, assigned });
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : 'Could not update');
    }
  }

  return (
    <AssignItemList
      items={forms.data}
      loading={forms.isLoading}
      pending={set.isPending}
      emptyTitle="No forms"
      emptyDescription="Build forms under Onboarding, Onboarding forms, then come back."
      onToggle={(id, assigned) => void toggle(id, assigned)}
    />
  );
}
